export class TrackPositionDto {
  public UserId: number
  public SourceType: number
  public Latitude: number
  public Longitude: number
  public DateTime: Date
  public BatteryStatus: string
  public LocationAccuracy: number
  public BestName: string
  public PhotoURL: string
  public LocationHeading?: number
  // public  LocationAltitude  :number
  // public  LocationAltitudeAccuracy  :number
  // public  LocationSpeed  :number
  // public  PositionSourceId  :number

  // SPOT satellite tracker fields — set only when IsSpotTracker = true
  public IsSpotTracker?: boolean
  public TrackerId?: number
  public TrackerName?: string
}
